export const json = {
  locale: 'ja_jp',
  recipe: "レシピ",
  machine: "マシン",
  task: {
    state: {
      unset: "未設定",
      todo: "未着手",
      in_progress: "進行中",
      to_test: "テスト待ち",
      wont_fix: "修正なし",
      done: "完了",
      paused: "一時停止",
    },
    priority: {
      unset: "優先度なし",
      low: "低",
      normal: "普通",
      high: "高",
      max: "緊急",
    },
    table: {
      header: {
        title: "タスク",
        state: "状態",
        priority: "優先度",
        labels: "ラベル",
      },
      placeholder: {
        filter: {
          priority: "メールをフィルタリング...",
        },
      },
      "no-results": "結果なし",
    },
    add: {
      title: "新しいタスクを追加",
      name: "タスク名",
      name_placeholder: "タスク名を入力",
      priority: "優先度",
      title_translations: "タイトル翻訳",
      description_translations: "説明翻訳",
      icon_url: "アイコンURL（オプション）",
      icon_url_placeholder: "アイコンURLを入力",
      labels: "ラベル",
      assigned_to: "担当者",
      assigned_to_placeholder: "モデレーターを選択",
      submit: "タスクを作成",
      cancel: "キャンセル",
      edit_translations: "翻訳を編集",
      save_translations: "翻訳を保存",
      required_field: "このフィールドは必須です",
      en_us_required: "英語（US）の翻訳が必要です",
      success: "タスクが正常に作成されました！",
      error: "タスクの作成中にエラーが発生しました。もう一度お試しください。",
    },
  },
  table: {
    select: {
      of: "の",
      rows: "行が選択されました。",
    },
  },
  cookies: {
    link: 'クッキーポリシー',
    title: "クッキーの同意",
    description:
      "このウェブサイトは、適切な機能を確保し、あなたの体験を向上させるためにクッキーを使用しています。どのクッキーの使用を許可するか選択してください。",
    policy_link: "クッキーポリシーで詳細を確認",
    accept_all: "すべて受け入れる",
    accept_selected: "選択したものを受け入れる",
    accept_essential: "必須のみ",
    manage: "設定を管理",
    save: "設定を保存",
    back: "戻る",
    categories: {
      essential: {
        title: "必須クッキー",
        description: "これらのクッキーはウェブサイトの機能に必要であり、無効にすることはできません。",
      },
      functional: {
        title: "機能的クッキー",
        description: "これらのクッキーはパーソナライズされた機能と特徴を可能にします。",
      },
      analytics: {
        title: "分析クッキー",
        description: "これらのクッキーは訪問者がウェブサイトとどのように相互作用するかを理解するのに役立ちます。",
      },
      marketing: {
        title: "マーケティングクッキー",
        description: "これらのクッキーは広告目的でウェブサイト間で訪問者を追跡するために使用されます。",
      },
    },
    expiration: {
      title: "クッキーの有効期限",
      description: "クッキー設定を記憶する期間を選択してください：",
      thirty_days: "30日間",
      ninety_days: "90日間",
      six_months: "6ヶ月間",
      one_year: "1年間",
    },
    policy: {
      title: "クッキーポリシー",
      introduction:
        "このクッキーポリシーは、当社のウェブサイトを訪問する際にあなたを認識するためにクッキーや類似の技術をどのように使用するかを説明しています。これらの技術が何であるか、なぜ使用するのか、およびそれらの使用を制御するあなたの権利について説明しています。",
      what_are_cookies: "クッキーとは何ですか？",
      what_are_cookies_text:
        "クッキーは、ウェブサイトを訪問する際にコンピュータやモバイルデバイスに配置される小さなデータファイルです。クッキーはウェブサイト所有者によって広く使用され、ウェブサイトを機能させたり、より効率的に機能させたり、レポート情報を提供したりします。",
      how_we_use: "クッキーの使用方法",
      how_we_use_text:
        "当社はいくつかの理由でクッキーを使用しています。一部のクッキーは、当社のウェブサイトが機能するために技術的な理由で必要であり、これらを「必須」または「必要」クッキーと呼んでいます。他のクッキーは、当社のウェブサイトでの体験を向上させるために、ユーザーの興味を追跡し、ターゲットにすることを可能にします。第三者は、広告、分析、その他の目的のために当社のウェブサイトを通じてクッキーを提供しています。",
      types: "使用するクッキーの種類",
      managing: "クッキーの管理",
      managing_text:
        "ウェブブラウザのコントロールを設定または変更して、クッキーを受け入れるか拒否するかを選択できます。クッキーを拒否することを選択した場合でも、当社のウェブサイトを引き続き使用できますが、ウェブサイトの一部の機能や領域へのアクセスが制限される場合があります。ウェブブラウザのコントロールを通じてクッキーを拒否する方法はブラウザによって異なるため、詳細についてはブラウザのヘルプメニューを参照してください。",
      third_party: "サードパーティのクッキー",
      third_party_text:
        "当社独自のクッキーに加えて、ウェブサイトの使用統計を報告したり、ウェブサイト上および経由で広告を配信したりするなど、さまざまなサードパーティのクッキーも使用する場合があります。",
      updates: "このクッキーポリシーの更新",
      updates_text:
        "当社は、使用するクッキーの変更や、その他の運用上、法的、または規制上の理由を反映するために、このクッキーポリシーを随時更新する場合があります。したがって、クッキーおよび関連技術の使用について最新の情報を得るために、このクッキーポリシーを定期的に再訪してください。",
      purpose: "目的",
      essential_purpose:
        "ウェブサイトの適切な機能に必要です。これらのクッキーは、ページナビゲーションやウェブサイトの安全な領域へのアクセスなどの基本的な機能を可能にします。",
      functional_purpose:
        "ウェブサイトがあなたの選択（ユーザー名、言語、または地域など）を記憶し、強化された、よりパーソナライズされた機能を提供することを可能にします。",
      analytics_purpose:
        "訪問者が当社のウェブサイトとどのように相互作用するかを理解するのに役立ち、情報を匿名で収集して報告します。",
      marketing_purpose:
        "ウェブサイト間で訪問者を追跡するために使用されます。意図は、個々のユーザーに関連性があり魅力的な広告を表示することです。",
      always_active: "常に有効",
      active: "有効",
      inactive: "無効",
      back_to_site: "サイトに戻る",
    },
  },
  sidebar: {
    platform: "プラットフォーム",
    dashboard: "ダッシュボード",
    tasks: {
      title: "タスク",
      add: "タスクを追加"
    },
    analytics: "分析",
    users: "ユーザー",
    settings: "設定",
    admin_panel: {
      title: "管理パネル",
      mods: {
        title: "モデレーター",
        add: "モデレーターを追加"
      },
      labels: {
        title: "ラベル",
        add: "ラベルを追加"
      },
      pending: "承認待ち"
    },
    documentation: {
      title: "ドキュメント",
      create: "ドキュメントを作成"
    },
    search: "ドキュメントを検索..."
  },
  pages: {
    user: {
      tabs: {
        overview: {
          title: "概要",
          userInfo: "ユーザー情報",
          userId: "ユーザーID",
          role: "役割",
          memberSince: "登録日"
        },
        tasks: {
          title: "タスク",
          assigned: "割り当てられたタスク",
          noTasks: "まだタスクが割り当てられていません。"
        },
        activity: {
          title: "アクティビティ",
          recent: "最近のアクティビティ",
          noActivity: "最近のアクティビティはありません。"
        },
        settings: {
          title: "設定",
          user: "ユーザー設定",
          admin: "このユーザーの管理者設定。"
        }
      }
    },
    mods: {
      error: {
        unknownError: "不明なエラー"
      },
      access: {
        title: "アクセス拒否",
        description: "このページにアクセスする権限がありません。"
      },
      add: {
        link: "新しいMODを追加",
        title: "新しいMODを追加",
        addDesc: "新しいMODエントリを作成",
        name: {
          title: "名前",
          placeholder: "MOD名を入力"
        },
        description: {
          title: "説明",
          placholder: "説明を入力 "
        },
        optional: "オプション",
        versions: {
          title: "バージョン",
          add: "バージョンを追加"
        },
        icon: "アイコンURL",
        launchers: "ランチャー",
        form: {
          errors: {
            alert: {
              title: "エラー",
              description: "送信する前に上記のエラーを修正してください。"
            },
            name: "名前は必須です",
            description: "英語（US）の説明は必須です",
            curseforge: "CurseForgeリンクは必須です",
            invalidURL: "無効なURL形式",
            versions: "少なくとも1つのバージョンが必要です",
            launchers: "少なくとも1つのランチャーが必要です"
          }
        },
        cancel: "キャンセル",
        create: {
          loading: "作成中...",
          default: "MODを作成"
        },
        langDataError: "言語データの読み込み中にエラーが発生しました：",
      },
      noMods: "MODが見つかりません",
      getStarted: "新しいMODを作成して始めましょう。",
      fetch: {
        error: 'ドキュメントの取得中にエラーが発生しました：'
      },
      "delete": {
        link: "削除",
        confirm: "このMODを削除してもよろしいですか？"
      },
      toast: {
        delete: {
          success: {
            title: "MODが削除されました",
            description: "MODは正常に削除されました。"
          },
          error: {
            console: "MODの削除中にエラーが発生しました：",
            fallback: "MODの削除に失敗しました",
            title: "エラー",
            description: "MODの削除中にエラーが発生しました。"
          }
        },
        edit: {
          success: {
            title: "成功",
            description: "MODが正常に更新されました"
          }
        },
        add: {
          fallback: "MODの作成に失敗しました",
          success: {
            title: "成功",
            description: "MODが正常に作成されました"
          },
          console: "MODの作成中にエラーが発生しました：",
          error: {
            title: "エラー",
            description: "MODの作成に失敗しました"
          }
        }
      },
      noDesc: "説明がありません",
      docs: {
        link: "ドキュメント"
      },
      edit: {
        link: "編集",
        title: "MODを編集",
        langDataError: "言語データの読み込み中にエラーが発生しました：",
        notFound: "MODが見つかりません",
        failFetch: "MODの取得に失敗しました",
        unknownError: "不明なエラーが発生しました",
        form: {
          errors: {
            name: "名前は必須です",
            description: "英語（US）の説明は必須です",
            curseforge: "CurseForgeリンクは必須です",
            versions: "すべてのバージョンフィールドを入力する必要があります",
            launchers: "少なくとも1つのランチャーを選択する必要があります"
          }
        },
        modInfo: "MOD情報",
        editModInfo: "MOD情報を編集します。",
        name: "名前",
        description: {
          title: "説明",
          required: "英語（US）の説明は必須です。"
        },
        optional: "オプション",
        versions: {
          title: "バージョン",
          add: "バージョンを追加",
          remove: "削除"
        },
        icon: "アイコンURL",
        launchers: "ランチャー",
        cancel: "キャンセル",
        update: "MODを更新"
      }
    },
    docs: {
      access: {
        title: "アクセス拒否",
        description: "このページにアクセスする権限がありません。"
      },
      title: "ドキュメント",
      description: "Minecraftモッドのドキュメントを閲覧して読む",
      create: {
        link: "ドキュメントを作成",
        tab: "新規作成",
        content: {
          title: "利用可能なMODがありません",
          description: "すべてのMODにはすでにドキュメントがあるか、MODのドキュメントを作成する権限がありません。"
        },
        title: "ドキュメントを作成"
      },
      published: "公開済み",
      pending: "保留中",
      noDocs: {
        title: "利用可能なドキュメントがありません",
        description: "まだ公開されたドキュメントページはありません。"
      },
      noPending: {
        title: "保留中のドキュメントはありません",
        superAdmin: "承認待ちのドキュメントページはありません",
        rest: "保留中のドキュメントページはありません。"
      },
      user: {
        noDocs: {
          title: "利用可能なドキュメントがありません",
          description: "まだ公開されたドキュメントページはありません。"
        }
      },
      card: {
        pending: "承認待ち",
        view: "表示",
        edit: "編集"
      },
      add: {
        title: "新しいドキュメントを作成",
        description: "Minecraftモッド用の包括的なドキュメントを作成",
        noMods: {
          title: "利用可能なMODがありません",
          description: "ドキュメント作成に利用可能なMODはありません。すべてのMODにはすでにドキュメントがあるか、MODのドキュメントを作成する権限がありません。"
        },
        card: {
          title: "基本情報",
          description: "ドキュメントに関する基本情報を提供してください。",
          descriptionLink: "ドキュメントガイドを見る",
          content: {
            modSelect: "MODを選択",
            modSelectDesc: "ドキュメントを作成したいMODを選択してください",
            noDesc: "説明がありません",
            form: {
              title: {
                title: "タイトル",
                placeholder: "ドキュメントのタイトルを入力",
                description: "ドキュメントのタイトル（英語USが必要）"
              },
              description: {
                title: "説明",
                placeholder: "ドキュメントの説明を入力",
                description: "ドキュメントの簡単な説明（英語USが必要）"
              },
              coverImage: {
                title: "カバー画像URL（オプション）",
                description: "ドキュメントのカバー画像のURLを提供してください"
              },
              tabs: {
                preview: {
                  title: "プレビュー",
                  content: {
                    title: "プレビュー",
                    description: "ドキュメントがどのように表示されるかのプレビュー",
                    form: {
                      title: "ドキュメントタイトル",
                      description: "ドキュメントの説明がここに表示されます。"
                    },
                    section: "セクション",
                    article: "記事",
                    modSelect: {
                      title: "MODを選択",
                      description: "ドキュメントをプレビューするMODを選択してください"
                    }
                  }
                },
                information: {
                  title: "情報",
                  content: {
                    title: "情報",
                    description: "ドキュメント作成に関する重要な情報",
                    approval: {
                      title: "承認が必要",
                      description: "編集者と管理者によって作成されたドキュメントは、公開される前にスーパー管理者の承認が必要です。これをリクエストするにはチケットを開いてください。"
                    },
                    after: {
                      title: "作成後：",
                      list: {
                        one: "ドキュメントエディタにリダイレクトされます",
                        two: "デフォルトのセクションと記事が自動的に作成されます",
                        three: "必要に応じて追加のセクションと記事を追加できます",
                        four: "画像をアップロードしてカスタムコンポーネントを追加できます",
                        five: "承認のために提出する前にドキュメントをプレビューできます。（プレビュー前に保存する必要があります）"
                      }
                    },
                    create: {
                      loading: "作成中...",
                      default: "ドキュメントを作成"
                    }
                  }
                }
              }
            }
          }
        },
        fetch: {
          mods: "MODの取得に失敗しました",
          documentation: "ドキュメントの取得に失敗しました"
        },
        success: {
          title: "ドキュメントが作成されました",
          description: "ドキュメントが正常に作成されました。"
        },
        error: {
          fetching: {
            mods: {
              console: "MODの取得中にエラーが発生しました：",
              toast: {
                title: "エラー",
                description: "MODの読み込みに失敗しました。もう一度お試しください。"
              }
            }
          },
          creating: {
            failed: "ドキュメントの作成に失敗しました",
            error: {
              console: "ドキュメントの作成中にエラーが発生しました：",
              toast: {
                title: "エラー",
                description: "ドキュメントの作成に失敗しました。もう一度お試しください。"
              }
            }
          }
        }
      }
    }
  }
}